import { render, staticRenderFns } from "./m-edit-css.vue?vue&type=template&id=0770882c&scoped=true&"
import script from "./m-edit-css.vue?vue&type=script&lang=js&"
export * from "./m-edit-css.vue?vue&type=script&lang=js&"
import style0 from "./m-edit-css.vue?vue&type=style&index=0&id=0770882c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0770882c",
  null
  
)

export default component.exports